import type { FaireProductEntity } from "../../entity_types/product";

export const p_nndvh46bud: FaireProductEntity = {
  token: "p_nndvh46bud",
  type: "product",
  name: 'Medium Barrel Bud Vase-Moss Green-4.5"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/d0169afc159eaf1f9231739788a3d7ead5446af6542534dcf266337db002923c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37858dfbb34d21ff52395aa2c3a1c01ddaa3598fc5b76da353262d19d3d6a98b.jpeg",
    "https://cdn.faire.com/fastly/f3e7a7280e05fc4e8d9f13fbcc1613cbe4a199e1f6d54f22f20dc2edaec5b8c1.jpeg",
    "https://cdn.faire.com/fastly/afa7e78b06bc33f4b15efa33b9d9f5afbca8664e464f6d924528b567d72f99c5.jpeg",
  ],
  priceDollars: 7,
  description:
    "Introducing our Medium Barrel Shaped Bud Vase, in dark and moody moss green, adding a pop of personality and style to your home decor. Made from high-quality glass, it features a sleek and slender design that beautifully showcases single blooms or small arrangements. Whether displayed individually or in a group, this artfully crafted colored glass bud vase brings beauty and sophistication to any space. Additional shapes and colours are available.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:13.048Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
